<template>
  <div class="d-flex">
    <v-menu v-if="isMenu" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>
      <v-list class="d-flex flex-row">
        <custom-form-btn-dialog
          i18n-path="actionplans"
          v-if="isPEM || isREE || isIEE"
          :has-tooltip="false"
          :has-label="hasLabel"
          :modal-props="{
            componentName: 'ActionplanFormDialog',
            componentProps: {
              multiPropertyIsForbidden: true,
              oldItem: actionPlan,
            },
          }"
        />
        <link-to-cofely-vision
          v-if="alert.m2m_remotemanagement_enabled === 'O'"
          :numins="alert.property_id"
          :has-label="hasLabel"
          has-sensors
          :region="alert.agency_region"
        />
      </v-list>
    </v-menu>
    <div v-else class="d-flex flex-row">
      <custom-form-btn-dialog
        i18n-path="actionplans"
        v-if="isPEM || isREE || isIEE"
        :has-tooltip="false"
        :has-label="hasLabel"
        :modal-props="{
          componentName: 'ActionplanFormDialog',
          componentProps: {
            multiPropertyIsForbidden: true,
            oldItem: actionPlan,
          },
        }"
      />
      <link-to-cofely-vision
        v-if="alert.m2m_remotemanagement_enabled === 'O'"
        :numins="alert.property_id"
        :has-label="hasLabel"
        has-sensors
        :region="alert.agency_region"
      />
    </div>
  </div>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import LinkToCofelyVision from '@/components/tools/LinkToCofelyVision';
import CustomFormBtnDialog from '@/components/dialogs/btnDialog/CustomFormBtnDialog';
import { mapGetters } from 'vuex';
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';

export default {
  name: 'alert-actions',
  components: { CustomFormBtnDialog, LinkToCofelyVision },
  props: {
    alert: { type: Object, required: true },
    hasLabel: { type: Boolean, default: true },
    isMenu: { type: Boolean, default: true },
  },
  computed: {
    ...mapGetters({
      isPEM: `${AUTHORIZATION_MODULE_PATH}/isPEM`,
      isREE: `${AUTHORIZATION_MODULE_PATH}/isREE`,
      isIEE: `${AUTHORIZATION_MODULE_PATH}/isIEE`,
    }),
    actionPlan() {
      const newActionPlan = {
        entity_id: this.alert.entity_id,
        node_id: this.alert.node_id,
        description: 'À renseigner',
        action_plan_origins: [],
        action_plan_type: 3,
      };
      const alertFields = [
        'alerte_legio_origin',
        'alerte_chauff_origin',
        'alerte_ecs_chauff_origin',
        'alerte_conso_origin',
        'alerte_conso_pct_origin',
        'alerte_conso_total_origin',
        'alerte_ecs_origin',
        'autres_alertes_origin',
      ];

      const alertValueFields = [
        { type: 'alerte_conso_origin', lib: 'Courant' },
        { type: 'alerte_conso_total_origin', lib: 'Cumulé' },
      ];

      alertFields.forEach((alertField) => {
        const priority = alertField.replace('origin', 'prio');
        if (
          this.alert[alertField] &&
          !!this.alert[priority] &&
          this.alert[priority] > 0
        ) {
          newActionPlan.action_plan_origins.push({
            origin_subtype_id: this.alert[alertField],
            datetime: this.alert[alertField.replace('origin', 'datetime')],
          });
        }
      });

      let customDesc = '';

      alertValueFields.forEach((alertField) => {
        const priority = alertField.type.replace('origin', 'prio');
        if (
          this.alert[alertField.type] &&
          !!this.alert[priority] &&
          this.alert[priority] > 0
        ) {
          customDesc += `Ecart Total ${alertField.lib} : ${
            this.alert[alertField.type.replace('origin', 'value')]
          } MWhPCI \n`;
        }
      });
      if (customDesc !== '') {
        newActionPlan.description = customDesc;
      }
      return newActionPlan;
    },
  },
  methods: {
    generateMessage,
  },
};
</script>
